/**
 * Application Constants
 *
 * Centralized configuration values used across the application.
 * Modify these values to adjust global settings.
 *
 * Priority (highest → lowest):
 *   1. window.__APP_CONFIG__  — injected by server.cjs from Azure App Settings (runtime)
 *   2. import.meta.env.*      — baked in by Vite from .env.production (build time)
 */

// Runtime config injected by server.cjs from Azure App Settings
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const runtimeCfg: Record<string, string> = (window as any).__APP_CONFIG__ || {};

const getRuntimeOrEnv = (key: string, envValue: string | undefined): string =>
  runtimeCfg[key] || envValue || '';

// API Configuration
const VERSION =
  getRuntimeOrEnv('VITE_API_VERSION', import.meta.env.VITE_API_VERSION) || 'v1';

export const API_CONFIG = {
  BASE_URL: getRuntimeOrEnv(
    'VITE_API_BASE_URL',
    import.meta.env.VITE_API_BASE_URL,
  ),
  VERSION,
  TIMEOUT: 10000, // 10 seconds - faster network error detection
  HUB_PREFIX: `/hub/${VERSION}`,
  API_PREFIX: `/api/${VERSION}`,
  // SSO endpoints - NO /v1 (OneLogin requires /api/auth/sso/*)
  SSO_LOGIN_URL: `/api/auth/sso/login`,
  SSO_CALLBACK_URL: `/api/auth/sso/callback`,
  SSO_METADATA_URL: `/api/auth/sso/metadata`,
} as const;

// Pagination
export const PAGE_SIZE = 10;

// File Operations
export const MAX_FILE_DOWNLOAD = 5;
export const MAX_FILE_UPLOAD = {
  sizeMB: 100,
  count: 10,
} as const;
